class MapImage {
  constructor(map) {
    this.map = map
    this.innerContainer = map.imageContainer.append('div')
    this.mapImage = this.innerContainer
      .append('img')
      .attr('crossOrigin', 'anonymous')
      .attr('src', map.map.url)
      .style('position', 'absolute')

    this.promise = new Promise((resolve, reject) => {
      const image = new Image()
      image.crossOrigin = 'Anonymous'

      image.onload = () => {
        resolve()
      }
      image.onerror = () => {
        this.mapImage.classed('error', true)
        reject()
      }
      image.src = map.map.url

      setTimeout(() => {
        reject()
      }, 15000)
    })
  }

  update(map) {
    this.map = map
  }

  onLoad() {
    return this.promise
  }

  draw({ dx, dy, screen, opacityScale, imageScale, transform: t }) {
    const { innerContainer, mapImage, map } = this

    map.imageContainer.style('width', `${screen.w + 50}px`).style('height', `${screen.h}px`)

    innerContainer
      .style('width', `${imageScale(map.map.w)}px`)
      .style('height', `${imageScale(map.map.h)}px`)
      .style('left', 0)
      .style('top', 0)
      .style('transform-origin', '0 0')
      .style('-webkit-transform-origin-x', '0px')
      .style('-webkit-transform-origin-y', '0px')
      .style('transform', `translate(${t.x + dx * t.k}px, ${t.y + dy * t.k}px) scale(${t.k})`)
      .style(
        '-webkit-transform',
        `translate(${t.x + dx * t.k}px, ${t.y + dy * t.k}px) scale(${t.k})`
      )

    mapImage
      .attr('id', 'floorImage')
      .style('width', '100%')
      .style('height', '100%')
      .style('opacity', opacityScale(t.k))
  }
}

export default MapImage
